import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { UnifiedLoginGuard } from '@monorepo/services';
import { ResolverApp } from './services/resolve/reolver-app.service';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./app-shell/app-shell.module').then((m) => m.AppShellModule),
    resolve: {
      __DO_NOT_USE_APP__: ResolverApp,
    },
    canActivate: [UnifiedLoginGuard],
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules,
      enableTracing: false,
      // relativeLinkResolution: 'legacy', [Migration] TODO: deprecated in angular 16, keep the uncomment for debuging in case, issue comes up
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
